// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"src/styles/variables/colors.css\"","lightCanard":"rgba(0,162,186, .40)","WithShadow":"styles-module--WithShadow--2jTGZ"};